import React from 'react';

function PDFPopup({ fileUrl, onClose, title }) {
    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg p-4 w-full max-w-4xl h-[90vh] flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">{title}</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-red-600 text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                <div className="flex-1 overflow-hidden">
               <iframe
  src={`${fileUrl}#toolbar=0&navpanes=0&view=FitH`}
  width="100%"
  height="100%"
  title="PDF Preview"
  className="border rounded-md"
/>

                </div>
            </div>
        </div>
    );
}

export default PDFPopup;
